// -----------------------------------------------------------------------------
// Filter für Investment und Corporate Summaries
// -----------------------------------------------------------------------------

import * as arrayUtility from '../arrayUtility';
import * as objectUtility from '../objectUtility';
import * as stringUtility from '../stringUtility';
import * as storageUtility from '../storageUtility';

const $container = $('.js-profile');
const $selectField = $container.find('.js-select');
const programValue = $container.find('.js-summary-filter').attr('data-program-value');
const storageKey = `summary-filter--${programValue}`;
const fields = $container.find('.js-summary-filter').attr('data-fields');

const init = () => {
  if ($container.length <= 0) {
    return;
  }

  // Filter-Einstellungen aus Storage holen
  applyFilterSettingsFromStorage();

  initEventListeners();
};

/**
 * Event-Listeners aktivieren
 */
const initEventListeners = () => {
  // Änderung im Formular
  $container.find('.js-summary-filter :input').change(function () {
    updateList();
  });

  // Klick auf Reset-Button
  $container.find('.js-summary-filter-reset-btn').click(function (e) {
    e.preventDefault();

    resetFilter();
  });
};

/**
 * Filter-Einstellungen aus Storgae übernehmen
 */
const applyFilterSettingsFromStorage = () => {
  const filterSettings = storageUtility.get(storageKey);

  // Abbruch, falls Filter in Storage nicht existiert
  if (filterSettings === null) {
    setResetBtn();
    return;
  }

  // Alle Filter-Einstellungen löschen
  $selectField.selectpicker('deselectAll');

  // Filter-Einstellungen aus Storage setzen
  for (const [key, value] of Object.entries(filterSettings)) {
    $container.find('#filter' + stringUtility.ucfirst(key)).selectpicker('val', value);
  }

  refreshFilter();
  updateList();
};

/**
 * Filter-Einstellungen holen und in Storage speichern
 *
 * @returns {{}}
 */
const fetchFilterSettings = () => {
  // Filter-Einstellungen holen
  let filterSettings = {};
  const aField = fields.split(';');

  aField.forEach(field => {
    filterSettings[field] = $('#filter' + stringUtility.ucfirst(field)).val();
  });

  // In Storage speichern
  storageUtility.save(storageKey, filterSettings);

  return filterSettings;
};

/**
 * Elemente abhängig von Filter-Einstellungen zeigen oder verstecken
 */
const updateList = () => {
  const oFilter = fetchFilterSettings();
  const aField = fields.split(';');

  // Elemente ein- bzw. ausblenden
  $container.find('.js-element').each(function () {
    // Kriterien-Objekt initialisieren
    let show = {};
    aField.forEach(field => {
      show[field] = false;
    });

    // Pro Filter-Feld prüfen, ob Kriterium zutrifft
    aField.forEach(field => {
      const aTmp = $(this).attr(`data-${field}`).split(';');
      if (arrayUtility.containsArrayPartially(oFilter[field], aTmp)) {
        show[field] = true;
      }
    });

    // Element zeigen, falls alle Kriterien zutreffen
    if (objectUtility.checkAndTrue(show)) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });

  setResetBtn();
};

/**
 * Reset-Button zeigen/verstecken
 */
const setResetBtn = () => {
  const notSelected = $container.find('.js-summary-filter option:not(:selected)');
  const $resetBtn = $container.find('.js-summary-filter-reset-btn');

  if (notSelected.length > 0) {
    $resetBtn.show();
  } else {
    $resetBtn.hide();
  }
};

/**
 * Filter zurücksetzen
 */
const resetFilter = () => {
  $selectField.selectpicker('selectAll');
  refreshFilter();
  updateList();
};

/**
 * Filter neu generieren
 */
const refreshFilter = () => {
  $selectField.selectpicker('refresh');
};

export {
  init
};
